export default __webpack_public_path__ + "static/media/check-blue.01b8b293.svg";